import { render } from "./RWSContour.vue?vue&type=template&id=6b1f9b34"
import script from "./RWSContour.vue?vue&type=script&lang=js"
export * from "./RWSContour.vue?vue&type=script&lang=js"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__